import type { FC } from "react";
import { ActivitiesListSkeleton } from "web_myplann/Activities/Components/ActivitiesListSkeleton";
import { useGoalsRightOptional } from "web_myplann/Api/Rights/RightsProvider";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { EmptyListSkeleton } from "web_myplann/Shared/Components/EmptyListSkeleton";

type Props = {
	description: string;
};

export const TimelineSkeleton: FC<Props> = ({ description }) => {
	const { t } = useResource();
	const hasGoalsRight = useGoalsRightOptional();

	return (
		<>
			{hasGoalsRight && <ActivitiesListSkeleton />}
			{!hasGoalsRight && (
				<EmptyListSkeleton
					label={t(Resources.NotificationCenter.Title)}
					description={description}
				/>
			)}
		</>
	);
};
